import $ from 'jquery';
import 'slick-carousel';
import isElement from '../../scripts/util/isElement';

const selectors = {
	slider: '.js--examples-slider'
};

const slickSettings = {
	infinite: true,
	arrows: false,
	dots: false,
	slidesToShow: 1,
	slidesToScroll: 2,
	speed: 300,
	adaptiveHeight: false,
	waitForAnimate: true,
	centerMode: true,
	centerPadding: '23px',
	fade: false,
	touchThreshold: 5,
	swipeToSlide: true,
	cssEase: 'ease',
	edgeFriction: 0.5
};

const sitesSlickCarousel = settings => {
	const slider = $(selectors.slider);
	slider.slick(settings);

	if (slider.hasClass('slick-initialized')) {
		slider.removeClass('is--hidden');
	}
};

const render = () => {
	if (isElement(selectors.slider)) {
		sitesSlickCarousel(slickSettings);
	}
};

export default render;



// WEBPACK FOOTER //
// ./app/blocks/gallery-examples/gallery-examples.js